import React from 'react'
import { Link } from 'react-router-dom'

function Team() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Our Team</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Team Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Frsixa Deam</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Alexa Nairo</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Merica Haric</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
              
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Steve Cross</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
              
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/5.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Martie Junior</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/6.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Madona Fron</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/7.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Samanta Crane</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/8.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Ostin Green</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                        <ul className="pagination">
                            <li className="page-item">
                                <Link className="page-link" to="#">
                                    Previous
                                </Link>
                            </li>
                            <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                            <li className="page-item">
                                <Link className="page-link" to="#">
                                    Next
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Team